import { offerAtom } from "@core/offers/atoms";
import { trans } from "@mongez/localization";

export function OfferDescription() {
  const offer = offerAtom.useValue();

  if (!offer.description) {
    return null;
  }

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800 sm:p-6">
      <h3 className="mb-3 text-base font-semibold text-gray-900 dark:text-gray-100 sm:mb-4 sm:text-lg">
        {trans("offers.description")}
      </h3>
      <div className="prose prose-gray max-w-none">
        <p className="leading-relaxed text-gray-600 dark:text-gray-300">
          {offer.description}
        </p>
      </div>
    </div>
  );
}
